module.exports = __webpack_public_path__ + "static/ms-card-25d8d1dec72477f8e337fe078d61390d.png";